module.exports = System.import('@enersis/gp-components/map');